import { render, staticRenderFns } from "./testcenter.vue?vue&type=template&id=ab50eeae"
import script from "./testcenter.vue?vue&type=script&lang=js"
export * from "./testcenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports